module.exports = __webpack_public_path__ + "static/img/digg-comment-default.43f0ceb3.png";